<template>
    <template v-if="(currentLayout == 'tabular') && (!this.hide_empty || componentData.data.length)">
        <div class="Block Workflowcard Item heading phasetitle">
            <div class="th-phasetitle">
                <h3 class="h3">{{ this.data.title }}</h3>
            </div>
        </div>
        <workflowcard-item
            v-for="(item, index) in componentData.data"
            :key="item.id"
            :data="item"
            :layout="currentLayout"
            :workflowboard_id="this.workflowboard_id"
            :workflowphase_id="this.data.id"
            :first="index === 0"
        >
            <template #workflowcard_item_actions="{data, layout}">
                <slot name="workflowcard_item_actions" :data="data" :layout="layout" />
            </template>
        </workflowcard-item>
        <template v-if="!componentData.loading && !componentData.data.length && currentLayout === 'tabular'">
            {{ trans("Momenteel zijn er geen items gekoppeld aan deze fase.") }}
        </template>
    </template>
    <article v-if="(currentLayout !== 'tabular') && (!this.hide_empty || componentData.data.length)" class="Block Workflowphase Item" :class="{default: (currentLayout == 'kanban'), [currentLayout]: true}">
        <div class="Heading" v-if="currentLayout !== 'list'">
            <h3 class="h3">{{ this.data.title }}</h3>
        </div>
        <div class="inner">
            <workflowcard-item
                v-for="(item, index) in componentData.data"
                :key="item.id"
                :data="item"
                :layout="currentLayout"
                :workflowboard_id="this.workflowboard_id"
                :workflowphase_id="this.data.id"
                :first="index === 0"
            >
                <template #workflowcard_item_actions="{data, layout}">
                    <slot name="workflowcard_item_actions" :data="data" :layout="layout" />
                </template>
            </workflowcard-item>
            <template v-if="!componentData.loading && !componentData.data.length && currentLayout === 'tabular'">
                {{ trans("Momenteel zijn er geen items gekoppeld aan deze fase.") }}
            </template>
        </div>
    </article>
</template>

<script>
import {defineComponent,  reactive, watch, inject, computed, onMounted, onUnmounted } from "vue";
import { useRoute } from "vue-router";

// External components
import workflowcardItem from "view/dashboard/includes/workflowcard-item";
import {getDataWithoutLimit} from "helpers/_api";
import { getUrlWithQueryItemReplaced } from "helpers/_structure";

import trans from "helpers/_translation";

import { generalFilters, resolveFilters, resolveAppFilters } from "store/filters";


// Config for API urls used in this vue template
import { config, apiHostname } from "config";

export default defineComponent({
	name: "workflowphase-overview",
	components: {
		workflowcardItem
	},
	props: {
		data: {
			type: Object,
			required: true
		},
		workflowboard_id: {
			type: String,
			required: true
		},


		hide_empty: {
			type: Boolean,
			required: false,
			default: false
		},

		// Extra props for usage within card view, related overview
		related_filter_json: {
			type: String,
			required: false,
			default: "{}"
		}
	},
	setup(props) {

		// Our route, used to get the current card id for relatedcards endpoint
		const route = useRoute();
		// Our configuration and constants
        const viewData = inject("viewData");
		const currentLayout = inject("currentLayout");

        const componentData = reactive({
            data: [],
            loading: true,
            init: false
        });
        const workflowphasesData = inject("workflowphasesData");

        const searchFilters = inject("searchFilters");
        const getData = () => {
            if (componentData.init) return;
            componentData.init = true;

            resolveAppFilters(viewData.extra_filters).then(extra_filters => {
                const filters = resolveFilters([
                    ...searchFilters.value,
                    [
                        "FieldFilter",
                        {
                            "column": "state",
                            "value": "Online"
                        }
                    ],
                    ...generalFilters.workflowboard[props.workflowboard_id ? parseInt(props.workflowboard_id) : viewData.workflowboard_id],
                    ...generalFilters.workflowusergroup,
                    ...generalFilters?.workflowrefine ?? [],
                    ...(extra_filters ?? [])
                ]);

                const phaseFilters = resolveFilters(props.data?.extra?.workflowfilter ?? []);
                if (phaseFilters) {
                    filters.push(...phaseFilters);
                }

                // console.log("generalFilters.workflowboard", JSON.parse(JSON.stringify(generalFilters.workflowboard)));
                // console.log("viewData.workflowboard_id", props.workflowboard_id ? parseInt(props.workflowboard_id) : viewData.workflowboard_id, generalFilters.workflowboard);
                // console.log("viewData.workflowphase_id", viewData.workflowphase_id, generalFilters.workflowphase);
                // console.log("phaseFilters",phaseFilters);
                // console.log("filters", JSON.parse(JSON.stringify(filters)), filters);

                let url = `${apiHostname}/api/v1.0/workflowcard`;
                if (viewData.workflowcard_id) {
                    url = `${apiHostname}/api/v1.0/workflowcard/${viewData.workflowcard_id}/relatedcards`;
                }
                if (viewData.sort) {
                    url = getUrlWithQueryItemReplaced("sort", viewData.sort, url);
                }
                if (viewData.order) {
                    url = getUrlWithQueryItemReplaced("order", viewData.order, url);
                }

                const tmpData = {
                    "data": []
                };
                const targetData = (viewData.realtime ? componentData : tmpData);
                getDataWithoutLimit(url, filters, targetData, "data").then(() => {
                        // Set data when finished loading instead
                        componentData.data = targetData.data;
                        componentData.loading = false;
                        if (targetData.data.length) {
                            workflowphasesData.loading = false;
                            workflowphasesData.hasitems = true;
                        }
                        if (workflowphasesData.loading_counter === Object.values(workflowphasesData.workflowphases).length - 1) {
                            workflowphasesData.loading = false;
                        }
                        workflowphasesData.loading_counter++;
                    }
                );
            });
        };
        let watcher = null;
        onMounted(() => {
            watcher = watch(
                () => generalFilters.workflowboard[props.workflowboard_id ? parseInt(props.workflowboard_id) : viewData.workflowboard_id],
                (newFilters, oldFilters) => {
                    if (typeof generalFilters.workflowboard[props.workflowboard_id ? parseInt(props.workflowboard_id) : viewData.workflowboard_id] === "undefined") return;
                    getData();
                    watcher && watcher();
                },
                {
                    immediate: true
                }
            );
        });
        onUnmounted(() => {
            watcher && watcher();
        });

		return {
            trans,

			currentLayout,

            componentData,
            viewData
		};
	},
});

</script>
